// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='6.6 5.21 26.93 29.58'
    ...attributes
  ><circle cx='20' cy='20' r='20' fill='none' /><g fill='#281e78'><path
        d='m20.097 34.786-13.5-6.715 5.765-2.873 7.772 3.868 7.696-3.849 5.7 2.854z'
        opacity='.5'
      /><path
        d='m20.097 26.721-13.5-6.715 5.765-2.873 7.772 3.868 7.696-3.849 5.7 2.854-13.433 6.714Z'
        opacity='.75'
      /><path
        d='m6.597 11.936 13.5-6.728 13.431 6.728-13.431 6.715Z'
      /></g></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'CardbotLg';
export default IconComponent;
